import { UserDropdownMenu } from "react-migration/components/UserMenu";
import { Stores, useGlobalState } from "react-migration/lib";
import { Feature } from "src/js/stores/user";
import { Intercom } from "src/js/util/intercom";

export const UserMenu = () => {
  const [{ user }, { hasFeature }] = useGlobalState(Stores.user);
  const usAccess = hasFeature(Feature.usAccess);

  return (
    <UserDropdownMenu
      fullName={`${user.firstname} ${user.surname}`}
      initials={`${user.firstname?.[0]}${user.surname?.[0]}`.toUpperCase()}
      plan={user.plan_name}
      onSupportClick={() => Intercom("show")}
      stripeManagedSignup={user.stripe_managed_signup}
      usAccess={usAccess}
    />
  );
};
